// Illust images
import '@/imgs/illust/help.jpg'
import '@/imgs/illust/help@2x.jpg'

import '@/imgs/illust/eliska-sovova.jpg'
import '@/imgs/illust/eliska-sovova@2x.jpg'
import '@/imgs/illust/michal-dorcak.jpg'
import '@/imgs/illust/michal-dorcak@2x.jpg'

import '@/imgs/illust/certifikat.png'

import '@/imgs/illust/ceska-posta.svg'
import '@/imgs/illust/gls.svg'
import '@/imgs/illust/slovenska-posta.svg'
import '@/imgs/illust/zasilkovna.svg'

import '@/imgs/illust/ceska-sporitelna.svg'
import '@/imgs/illust/kb.svg'
import '@/imgs/illust/raiffeisen.svg'
import '@/imgs/illust/csob.svg'

import '@/imgs/illust/sada-testu-5-trida.png'
import '@/imgs/illust/sada-testu-5-trida@2x.png'
